import React from 'react';
import { useTheme } from '@context/ThemeContext';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  className,
  ...props
}) => {
  const { themeConfig } = useTheme();
  return (
    <div className="w-full">
      {label && (
        <label className={`block text-sm font-medium ${themeConfig.header.text} mb-1`}>
          {label}
        </label>
      )}
      <input
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-colors ${
          error ? 'border-red-500' : themeConfig.sidebar.border
        } ${className || ''}`}
        {...props}
      />
      {error && (
        <p className="text-red-600 text-sm mt-1">{error}</p>
      )}
      {helperText && !error && (
        <p className={`${themeConfig.sidebar.textTertiary} text-sm mt-1`}>{helperText}</p>
      )}
    </div>
  );
};
